import { apiService } from './apiService';
import { MedicationCatalog } from '../models/medication';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.eternal-health.com/api';

export interface MedicationCatalogPaginatedResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: MedicationCatalog[];
  totalPages: number;
  actualPage: number;
}

export interface CreateMedicationData {
  name: string;
  purchaseUrl?: string;
  description?: string;
}

export const medicationCatalogService = {
  getAll: async (page: number = 1, pageSize: number = 10, search: string = ''): Promise<MedicationCatalogPaginatedResponse> => {
    const params = new URLSearchParams({ page: String(page), page_size: String(pageSize) });
    if (search.trim()) params.set('search', search.trim());
    const url = `${API_BASE_URL}/clinic/medication-catalog/?${params.toString()}`;
    try {
      const response = await apiService.get(url);
      return {
        ...response,
        actualPage: page,
        totalPages: Math.ceil(response.count / pageSize) || 1,
      };
    } catch (error) {
      console.error('Error fetching medication catalog:', error);
      throw error;
    }
  },

  getOne: async (id: number): Promise<MedicationCatalog> => {
    const url = `${API_BASE_URL}/clinic/medication-catalog/${id}/`;
    try {
      const response = await apiService.get(url);
      return response;
    } catch (error) {
      console.error(`Error fetching medication ${id}:`, error);
      throw error;
    }
  },

  create: async (data: CreateMedicationData): Promise<MedicationCatalog> => {
    const url = `${API_BASE_URL}/clinic/medication-catalog/`;
    try {
      const response = await apiService.post(url, data);
      return response;
    } catch (error) {
      console.error('Error creating medication:', error);
      throw error;
    }
  },

  update: async (id: number, data: Partial<CreateMedicationData>): Promise<MedicationCatalog> => {
    const url = `${API_BASE_URL}/clinic/medication-catalog/${id}/`;
    try {
      const response = await apiService.patch(url, data);
      return response;
    } catch (error) {
      console.error(`Error updating medication ${id}:`, error);
      throw error;
    }
  },

  remove: async (id: number): Promise<void> => {
    const url = `${API_BASE_URL}/clinic/medication-catalog/${id}/`;
    try {
      await apiService.delete(url);
    } catch (error) {
      console.error(`Error deleting medication ${id}:`, error);
      throw error;
    }
  },
};
